import { lazy } from "react";

const BoardingHouse = lazy(() => import("@views/BoardingHouse"))

const HouseRoutes = [
    {
        path: '/other/boardinghouse',
        element: <BoardingHouse />
    },
]

export default HouseRoutes
